import React from 'react'
import {
  Link,
  Text,
  Box,
  Flex,
  Hide,
  getPaletteColor
} from 'pcln-design-system'
import styled from 'styled-components'
import analytics from '@/shared-utils/analytics'
import { ANALYTICS_CATEGORY_HOME } from '@/constants/analytics'
import { getProductIconFilled } from './utils'

const NoInventoryWrapper = styled(Flex)`
  background-color: transparent;
  flex-direction: row;
  align-items: center;
`

const InventoryTextWrapper = styled(Flex)`
  flex-direction: column;
  justify-content: center;
  width: 100%;
`

const TextSpan = Text.span

export default function NoInventoryFallback({
  xSellMessaging,
  xSellTarget,
  xSellUrl
}: {
  xSellMessaging: string
  xSellTarget: 'Rental Cars' | 'Hotels' | 'Flights'
  xSellUrl: string
}) {
  const ProductIcon = getProductIconFilled(xSellTarget || 'hotel')
  return (
    <NoInventoryWrapper
      color="background.lightest"
      borderRadius="xl"
      py={3}
      px={24}
      width={[1, 2 / 3, 8 / 11]}
      data-testid="no-inventory-fallback"
    >
      <Hide xs sm md>
        <Flex
          justifyContent="center"
          alignItems="center"
          borderRadius="full"
          mr={4}
          width="80px"
          height="80px"
          bg={getPaletteColor('background.lightest')}
        >
          <ProductIcon size="32px" />
        </Flex>
      </Hide>

      <InventoryTextWrapper>
        <Flex>
          <Hide xxl xl lg>
            <Flex
              justifyContent="center"
              alignItems="center"
              borderRadius="full"
              mr={2}
              width="56px"
              height="56px"
              bg={getPaletteColor('background.lightest')}
            >
              <ProductIcon size="32px" />
            </Flex>
          </Hide>
          <Box>
            <Box
              color="highlight.light"
              mr="auto"
              px={2}
              py={1}
              borderRadius="lg"
              mb={2}
              display="table"
            >
              <Text color="highlight.shade" fontSize={12} bold>
                SAVE UP TO 40%
              </Text>
            </Box>
            <Text
              color="text.heading"
              textStyle={['heading5', null, 'heading3']}
              mb={3}
            >
              {xSellMessaging}
            </Text>
          </Box>
        </Flex>
        <TextSpan>
          <Link
            onClick={() => {
              analytics.fireEvent({
                action: 'Feature Box CTA',
                category: ANALYTICS_CATEGORY_HOME,
                label: 'Cross Sell Search Button'
              })
            }}
            href={xSellUrl}
            target="_blank"
            data-testid="XSELL_SEARCH_BUTTON"
            variation="fill"
          >
            Search {xSellTarget}
          </Link>
        </TextSpan>
      </InventoryTextWrapper>
    </NoInventoryWrapper>
  )
}
